import { DashboardType } from "@doitintl/cmp-models";
import { Typography } from "@mui/material";

import { KubernetesLensDashboard } from "../../K8s/Dashboard/KubernetesLens";

interface EmbeddedDashboardProps {
  dashboardType: DashboardType | null | undefined;
}

const componentByDashboardType: Partial<Record<DashboardType, React.ComponentType>> = {
  [DashboardType.KubernetesLens]: KubernetesLensDashboard,
};

const EmbeddedDashboard = ({ dashboardType }: EmbeddedDashboardProps) => {
  if (!dashboardType) {
    return <Typography variant="h6">No dashboard type provided</Typography>;
  }

  const Component = componentByDashboardType[dashboardType];

  if (Component) {
    return <Component />;
  }

  return <Typography variant="h6">No component found for this dashboard type</Typography>;
};

export default EmbeddedDashboard;
